import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import EventCalendar from '../components/EventCalendar';
import appActions from '../redux/actions/appActions';
import actions from '../redux/actions/equestrianActions';
import EquestrianEventResultCr from '../containers/EquestrianEventResultCr';

const SportInfo = {
  sectionName : 'Equestrian',
  slug: 'equestrian'
}


const mapStateToProps = state => {
  return { events: state.events.equestrian };
};

const mapDispatchToProps = dispatch => ({
    setAppSection: () => { dispatch(appActions.setAppSection({appSection: 'equestrian'}))},
    resetFilters: () => { dispatch(appActions.resetFilters())},
    appInLoading: (bool) => { dispatch(appActions.appInLoading(bool))},
    fetchListing: (year) => { dispatch(actions.fetchEquestrianListing(year))},
  }
)

class EventListingCr extends Component {

  fetchListingFromProvider(){
    const { match } = this.props;
    const year = match.params.year || (new Date()).getFullYear();
    this.props.fetchListing(year);
  }

  componentWillMount(){
    this.props.resetFilters();
    sessionStorage.setItem('lti:lastVisitedSection', SportInfo.slug);
  }

  componentDidMount(){
    this.props.setAppSection();
    this.fetchListingFromProvider();
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    if(match.params.year !== prevProps.match.params.year){
      this.fetchListingFromProvider();
    }

    setTimeout(()=>{
      this.props.appInLoading(false);
    }, 500);
  }

  render(){
    const { match, history, events} = this.props;
    const year = match.params.year || (new Date()).getFullYear();
    const eventListing =  events[year] || [];

    window.ga('send', 'pageview', match.url);

    return (
      <div className="container">
        <Switch>
          <Route path="/equestrian/lite/:year/:eventId/*" component={EquestrianEventResultCr} />
          <Route path="/equestrian/lite/:year/:eventId" component={EquestrianEventResultCr} />
          <Route path="/equestrian/:year/:eventId/*" component={EquestrianEventResultCr} />
          <Route path="/equestrian/:year/:eventId" component={EquestrianEventResultCr} />
          <Route path="/equestrian/:year?" render={(props) => <EventCalendar {...props} events={eventListing} SportInfo={SportInfo} history={history} />} />
        </Switch>
      </div>
    )
  }
}

const EquestrianEventListingDecorated = withRouter(props => <EventListingCr {...props}/>);
const EquestrianEventListingDecoratedRx = connect(mapStateToProps, mapDispatchToProps)(EquestrianEventListingDecorated);

export default EquestrianEventListingDecoratedRx
